import { createGlobalStyle } from 'styled-components';

export const CSSReset = createGlobalStyle`
  *:focus {
    outline: none;
  }
`;
